export const PORTFOLIO_POSITION_VERSION = "1.0.0";

const BASE_PORTFOLIO_POSITION = {
  exposure: {
    grossEal: null,
    grossP95: null,
    grossP99: null,
  },
  mitigation: {
    annualInvestment: null,
    expectedLossReduction: null,
    residualEalBeforeTransfer: null,
    residualP95BeforeTransfer: null,
  },
  transfer: {
    annualPremium: null,
    deductible: null,
    policyLimit: null,
    coinsurance: null,
    expectedTransferredLoss: null,
  },
  retained: {
    expectedRetainedLoss: null,
    retainedP95: null,
    retainedP99: null,
  },
  residual: {
    expectedAnnualLoss: null,
    capitalAtRiskP95: null,
    capitalAtRiskP99: null,
  },
  capital: {
    mitigationCost: null,
    transferCost: null,
    retainedCapital: null,
    totalRiskCost: null,
  },
  coverage: {
    activeScenarios: null,
    coveredScenarios: null,
    uncoveredScenarios: null,
    activeCoverages: null,
    expiringCoverages: null,
    coverageRatio: null,
  },
  metadata: {
    currency: null,
    simulations: null,
    generatedAt: null,
    source: null,
    version: PORTFOLIO_POSITION_VERSION,
  },
};

export function createPortfolioPosition(overrides = {}) {
  return {
    exposure: { ...BASE_PORTFOLIO_POSITION.exposure, ...overrides.exposure },
    mitigation: { ...BASE_PORTFOLIO_POSITION.mitigation, ...overrides.mitigation },
    transfer: { ...BASE_PORTFOLIO_POSITION.transfer, ...overrides.transfer },
    retained: { ...BASE_PORTFOLIO_POSITION.retained, ...overrides.retained },
    residual: { ...BASE_PORTFOLIO_POSITION.residual, ...overrides.residual },
    capital: { ...BASE_PORTFOLIO_POSITION.capital, ...overrides.capital },
    coverage: { ...BASE_PORTFOLIO_POSITION.coverage, ...overrides.coverage },
    metadata: {
      ...BASE_PORTFOLIO_POSITION.metadata,
      ...overrides.metadata,
      version: PORTFOLIO_POSITION_VERSION,
    },
  };
}

export const EMPTY_PORTFOLIO_POSITION = createPortfolioPosition();
